import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirLocalSysChartAcctMapService {

  constructor(private http: HttpClient) { }

  /**
   * Get System Account Dropdown
   * Action Code: pfwnw7
   */
  getSystemAcctDropdown(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get System Account Lookup
   * Action Code: oz9yxt
   */
  getSystemAcctLookup(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get Tax Sensitive Data
   * Action Code: q7exhh
   */
  getTaxSensitiveData(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get Posting Local Account List
   * Action Code: posting_acct
   */
  getPostingLocalAcctList(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get Offset Local Account List
   * Action Code: offset_acct
   */
  getOffsetLocalAcctList(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get F5471 Schedule H Data
   * Action Code: x0exu7
   */
  getF5471SchdHData(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get F8865 Schedule M1 Data
   * Action Code: zn1cxr
   */
  getF8865SchdM1Data(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get Local Posting Account
   * Action Code: xzxjuh
   */
  getLocalPostingAcct(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, params, globalService);
  }

  /**
   * Get System Account Form Data (IRS Form table)
   * Action Code: 4fmxwf
   * Uses GET request with query params (matching original AngularJS)
   */
  getSystemAcctFormData(baseUrl: string, params: any, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeGetRequest(url, params, globalService);
  }

  /**
   * Save FIR Form Details
   * Endpoint: /saveJsonObject?action_code=9h4eue
   * Process: FIR_LOCAL_TO_SYSTEM_SAVE
   * Matching original AngularJS: saveFIRFormDetails(local_system_accounts, saveTaxSensitiveData)
   */
  saveFIRFormDetails(
    baseUrl: string,
    localSystemAccounts: any[],
    saveTaxSensitiveData: any[],
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=9h4eue`;

    // jsonObj = JSON.stringify(saveTaxSensitiveData) - tax sensitive details
    // jsonSettings = JSON.stringify(localSystemAccounts) - local to system mapping
    const jsonObj = JSON.stringify(saveTaxSensitiveData);
    const jsonSettings = JSON.stringify(localSystemAccounts);

    let params: any = { ...filterParams };
    if (globalService?.globalParams) {
      params = { ...globalService.globalParams, ...params };
    }

    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettings;
    params.process_name = 'FIR_LOCAL_TO_SYSTEM_SAVE';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true }).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error in saveFIRFormDetails:', error);
        throw error;
      })
    );
  }

  private makeRequest(url: string, params: any, globalService: any): Observable<any> {
    let requestParams: any = { ...params };
    if (globalService?.globalParams) {
      requestParams = { ...globalService.globalParams, ...requestParams };
    }

    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true }).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error in request:', error);
        throw error;
      })
    );
  }

  /**
   * Make GET request with query params (for API calls like fetchSystemAcctFormData)
   */
  private makeGetRequest(url: string, params: any, globalService: any): Observable<any> {
    let requestParams: any = { ...params };
    if (globalService?.globalParams) {
      requestParams = { ...globalService.globalParams, ...requestParams };
    }

    // Build query string
    const queryParams = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        queryParams.set(key, requestParams[key].toString());
      }
    });

    const fullUrl = `${url}?${queryParams.toString()}`;

    return this.http.get<any>(fullUrl, { withCredentials: true }).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error in GET request:', error);
        throw error;
      })
    );
  }
}


